<template>
	<div class="content modOverview">
		<div class="subContent">
			<h1>{{$t('menu_overview')}}</h1>
			<form id="form_overview" name="form_overview" v-on:submit.prevent="onSubmit">

				<div class="form-group row">
					<div class="col-2 width-150">
						<input ref="search_merchant" class="form-control" id="search_merchant" name="search_merchant" type="text" v-model="search_merchant" placeholder="Search Merchant">
					</div>
					<div class="col-8 col-form-label" style="text-align: left;white-space: nowrap;" v-show="!overview_search">
						<span class="pointer" @click="openSearchOrder">[ + ]</span>
					</div>
					<div class="col-1 col-form-label" style="text-align: left;white-space: nowrap;" v-show="overview_search">
						<span class="pointer" v-on:click="overview_search = !overview_search">[ - ]</span>
					</div>
					<div class="col-3" v-show="overview_search">
						<input class="form-control" id="search_order" name="search_order" v-model="search_order" type="text" placeholder="Order / E-mail / Internal number / Tax ID">
					</div>
					<div class="col-3" v-show="overview_search">
						<b-select  id="search_order_tipo" name="search_order_tipo" v-model="search_order_tipo">
							<option value="order">{{$t('search_tipo_order')}}</option>
							<option value="internal_number">{{$t('search_tipo_internal_number')}}</option>
							<option value="email">{{$t('search_tipo_email')}}</option>
							<option value="taxid">{{$t('search_tipo_taxid')}}</option>
						</b-select>
					</div>
					<div class="col-3 submitOverview" v-show="overview_search">
						<input class="form-control" type="submit" style="min-width:90px;" name="" v-on:click="search_order_overview()" :value="$t('search')">
					</div>
				</div>

			</form>

			<div class="boxContent">
				<div v-show="merchant_online_search.length > 0" class="overview_group">
					<div class="overview_header" @click="changeShowOnline">
						<i class="el-icon-arrow-down" style="padding: 0px 3px" v-if="showOnline"></i>
						<i class="el-icon-arrow-up" style="padding: 0px 3px" v-else></i>
						{{$t('overview_online_acc')}} ({{merchant_online_search.length}})
					</div>

					<!-- Merchants PB Eleva -->
					<b-row class="ml-2" v-if="showOnline">

						<div v-show="merchant_online_pb_eleva_search.length > 0" class="touch_rating_header darkNavy" @click="changeShowOnlinePBEleva">

							<i class="el-icon-arrow-down" style="padding: 0px 3px" v-if="showOnlinePBEleva"></i>
							<i class="el-icon-arrow-up" style="padding: 0px 3px" v-else></i>
							{{ $t('overview_pb_eleva') }} ({{ merchant_online_pb_eleva_search.length }})
						</div>

						<div v-for="mer in merchant_online_pb_eleva_search" v-if="showOnlinePBEleva"
							:title="'(' + mer.number + ') ' + mer.name + type_translate(mer.type)"
							:key="'on' + mer.number"
							class="overview_item overview_online"
							v-on:click="setMerchant(mer)"
							:class="{ merchant_find: mer.find==1, wordbreak: (mer.name.length > 25) }">
							<div class="overview_item_text">({{ mer.number }}) {{ mer.name | limiteName }}</div>
							<div class="infoTipoMerc" v-if="mer.type != '1'">{{ mer.type | type_translate }} {{ mer.gateway | gateway_translate }}</div>
						</div>

					</b-row>

					<!-- Merchants Top tier -->
					<b-row class="ml-2" v-if="showOnline">
						<div v-show="merchant_online_top_tear_search.length > 0" class="touch_rating_header yellow" @click="changeShowOnlineTopTier">
							<i class="el-icon-arrow-down" style="padding: 0px 3px" v-if="showOnlineTopTier"></i>
							<i class="el-icon-arrow-up" style="padding: 0px 3px" v-else></i>
							{{$t('overview_top_tier')}} ({{merchant_online_top_tear_search.length}})
						</div>

						<div v-for="mer in merchant_online_top_tear_search" v-if="showOnlineTopTier"
							:title="'(' + mer.number + ') ' + mer.name + type_translate(mer.type)"
							:key="'on' + mer.number"
							class="overview_item overview_online"
							v-on:click="setMerchant(mer)"
							:class="{ merchant_find: mer.find==1, wordbreak: (mer.name.length > 25) }">

							<div class="overview_item_text">({{mer.number}}) {{mer.name | limiteName}}</div>
							<div class="infoTipoMerc" v-if="mer.type != '1'">{{mer.type | type_translate}}{{ mer.gateway | gateway_translate }}</div>
						</div>
					</b-row>

					<!-- Merchants High touch -->
					<b-row class="ml-2" v-if="showOnline">
						<div v-show="merchant_online_high_touch_search.length > 0" class="touch_rating_header green" @click="changeShowOnlineHighTouch">
							<i class="el-icon-arrow-down" style="padding: 0px 3px" v-if="showOnlineHighTouch"></i>
							<i class="el-icon-arrow-up" style="padding: 0px 3px" v-else></i>
							{{$t('overview_high_touch')}} ({{merchant_online_high_touch_search.length}})
						</div>

						<div v-for="mer in merchant_online_high_touch_search"
						 	v-if="showOnlineHighTouch"
							:title="'(' + mer.number + ') ' + mer.name + type_translate(mer.type)"
							:key="'on' + mer.number"
							class="overview_item overview_online"
							v-on:click="setMerchant(mer)"
							:class="{ merchant_find: mer.find==1, wordbreak: (mer.name.length > 25) }">

							<div class="overview_item_text">({{mer.number}}) {{mer.name | limiteName}}</div>
							<div class="infoTipoMerc" v-if="mer.type != '1'">{{mer.type | type_translate}}{{ mer.gateway | gateway_translate }}</div>
						</div>
					</b-row>

					<!-- Merchants Middle touch -->
					<b-row class="ml-2" v-if="showOnline">
						<div v-show="merchant_online_middle_touch_search.length > 0" class="touch_rating_header blue" @click="changeShowOnlineMiddleTouch">
							<i class="el-icon-arrow-down" style="padding: 0px 3px" v-if="showOnlineMiddleTouch"></i>
							<i class="el-icon-arrow-up" style="padding: 0px 3px" v-else></i>
							{{$t('overview_middle_touch')}} ({{merchant_online_middle_touch_search.length}})
						</div>

						<div v-for="mer in merchant_online_middle_touch_search"
							v-if="showOnlineMiddleTouch"
							:title="'(' + mer.number + ') ' + mer.name + type_translate(mer.type)"
							:key="'on' + mer.number"
							class="overview_item overview_online"
							v-on:click="setMerchant(mer)"
							:class="{ merchant_find: mer.find==1, wordbreak: (mer.name.length > 25) }">

							<div class="overview_item_text">({{mer.number}}) {{mer.name | limiteName}}</div>
							<div class="infoTipoMerc" v-if="mer.type != '1'">{{mer.type | type_translate}}{{ mer.gateway | gateway_translate }}</div>
						</div>
					</b-row>

					<!-- Merchants Low touch -->
					<b-row class="ml-2" v-if="showOnline">
						<div v-show="merchant_online_low_touch_search.length > 0" class="touch_rating_header red" @click="changeShowOnlineLowTouch">
							<i class="el-icon-arrow-down" style="padding: 0px 3px" v-if="showOnlineLowTouch"></i>
							<i class="el-icon-arrow-up" style="padding: 0px 3px" v-else></i>
							{{$t('overview_low_touch')}} ({{merchant_online_low_touch_search.length}})
						</div>

						<div v-for="mer in merchant_online_low_touch_search"
							v-if="showOnlineLowTouch"
							:title="'(' + mer.number + ') ' + mer.name + type_translate(mer.type)"
							:key="'on' + mer.number"
							class="overview_item overview_online"
							v-on:click="setMerchant(mer)"
							:class="{ merchant_find: mer.find==1, wordbreak: (mer.name.length > 25) }">

							<div class="overview_item_text">({{mer.number}}) {{mer.name | limiteName}}</div>
							<div class="infoTipoMerc" v-if="mer.type != '1'">{{mer.type | type_translate}}{{ mer.gateway | gateway_translate }}</div>
						</div>
					</b-row>

					<!-- Merchants sem touch -->
					 <b-row class="ml-2" v-if="showOnline">
						<div v-show="merchant_online_none_touch_search.length > 0" class="touch_rating_header black" @click="changeShowOnlineNoneTouch">
							<i class="el-icon-arrow-down" style="padding: 0px 3px" v-if="showOnlineNoneTouch"></i>
							<i class="el-icon-arrow-up" style="padding: 0px 3px" v-else></i>
							{{$t('overview_none_touch')}} ({{merchant_online_none_touch_search.length}})
						</div>

						<div v-for="mer in merchant_online_none_touch_search" v-if="mer.touch_rating_code == null && showOnlineNoneTouch"
							:title="'(' + mer.number + ') ' + mer.name + type_translate(mer.type)"
							:key="'on' + mer.number"
							class="overview_item overview_online"
							v-on:click="setMerchant(mer)"
							:class="{ merchant_find: mer.find==1, wordbreak: (mer.name.length > 25) }">

							<div class="overview_item_text">({{mer.number}}) {{mer.name | limiteName}}</div>
							<div class="infoTipoMerc" v-if="mer.type != '1'">{{mer.type | type_translate}}{{ mer.gateway | gateway_translate }}</div>
						</div>
					 </b-row>
				</div>

				<div v-show="merchant_testing_search.length > 0" class="overview_group">
					<div class="overview_header" @click="changeShowTesting">
						<i class="el-icon-arrow-down" style="padding: 0px 3px" v-if="showTesting"></i>
						<i class="el-icon-arrow-up" style="padding: 0px 3px" v-else></i>
						{{$t('overview_testing_acc')}} ({{merchant_testing_search.length}})
					</div>
					<div v-for="mer in merchant_testing_search" v-if="showTesting"
						:title="'(' + mer.number + ') ' + mer.name + type_translate(mer.type)"
						:key="'test' + mer.number"
						class="overview_item overview_testing"
						v-on:click="setMerchant(mer)"
						:class="{ merchant_find: mer.find==1, wordbreak: (mer.name.length > 25) }">

						({{mer.number}}) {{mer.name | limiteName}}
						<div class="infoTipoMerc" v-if="mer.type != '1'">{{mer.type | type_translate}}{{ mer.gateway | gateway_translate }}</div>
					</div>
				</div>

				<div v-show="merchant_closed_search.length > 0" class="overview_group">
					<div class="overview_header"  @click="changeShowClosed">
						<i class="el-icon-arrow-down" style="padding: 0px 3px" v-if="showClosed"></i>
						<i class="el-icon-arrow-up" style="padding: 0px 3px" v-else></i>
						{{$t('overview_closed_acc')}} ({{merchant_closed_search.length}})
					</div>
					<div v-for="mer in merchant_closed_search" v-if="showClosed"
						:title="'(' + mer.number + ') ' + mer.name + type_translate(mer.type)"
						:key="'clo' + mer.number"
						class="overview_item overview_closed"
						v-on:click="setMerchant(mer)"
						:class="{ merchant_find: mer.find==1, wordbreak: (mer.name.length > 25) }">

						({{mer.number}}) {{mer.name | limiteName}}
						<div class="infoTipoMerc" v-if="mer.type != '1'">{{mer.type | type_translate}}{{ mer.gateway | gateway_translate }}</div>
					</div>
				</div>

				<div v-show="merchant_testing_closed_search.length > 0" class="overview_group">
					<div class="overview_header"  @click="changeShowTestingClosed">
						<i class="el-icon-arrow-down" style="padding: 0px 3px" v-if="showTestingClosed"></i>
						<i class="el-icon-arrow-up" style="padding: 0px 3px" v-else></i>
						{{$t('overview_testing_closed_acc')}} ({{merchant_testing_closed_search.length}})
					</div>
					<div v-for="mer in merchant_testing_closed_search" v-if="showTestingClosed"
						:title="'(' + mer.number + ') ' + mer.name + type_translate(mer.type)"
						:key="'tclo' + mer.number"
						class="overview_item overview_closed"
						v-on:click="setMerchant(mer)"
						:class="{ merchant_find: mer.find==1, wordbreak: (mer.name.length > 25) }">

						({{mer.number}}) {{mer.name | limiteName}}
						<div class="infoTipoMerc" v-if="mer.type != '1'">{{mer.type | type_translate}}{{ mer.gateway | gateway_translate }}</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>

export default {

	template: "#overview",
	data () {
		return {
			"merchant_online": [],
			"merchant_online_none_touch": [],
			"merchant_online_low_touch": [],
			"merchant_online_middle_touch": [],
			"merchant_online_high_touch": [],
			"merchant_online_top_tear": [],
			"merchant_online_pb_eleva": [],
			"merchant_testing": [],
			"merchant_closed": [],
			"merchant_testing_closed": [],
			"search_merchant": '',
			"search_order": '',
			"search_order_tipo": 'order',
			"overview_search": false,
			"perm": {
                "user": {},
                "perm": {},
                "especial": {}
            },
			"showOnline": true,
			"showOnlinePBEleva": true,
			"showOnlineTopTier": true,
			"showOnlineLowTouch": true,
			"showOnlineMiddleTouch": true,
			"showOnlineHighTouch": true,
			"showOnlineNoneTouch": true,
			"showTesting": true,
			"showClosed": true,
			"showTestingClosed": true,
		}
	},

	beforeMount() {
		this.perm = JSON.parse(localStorage.getItem('perm'));
    },

	mounted() {
		let progress = document.getElementById('loaderProgress').children[0];
		progress.innerHTML = "";

		let xpp  = this.$cookie.get('xpp');
		let realxpp	= this.$cookie.get('realxpp');

		if (realxpp != '*' || this.perm.user.tipo != 'S') {
			this.$helper.pushRouteTo({ name: 'Login' });
			return;
		}

		this.$cookie.set('xpp', '*', {"SameSite": "None", "Secure": ""});

		this.getListMerchant();

		this.$nextTick(() => {
			this.$refs.search_merchant.focus();
		});
	},

	watch: {
		search_order(newval, oldval) {
			if (newval == "") {
				this.getListMerchant();
			}
        }
	},

	computed: {
		merchant_online_search() {
			this.showOnline 			= true;
			this.showOnlinePBEleva 		= true;
			this.showOnlineTopTier 		= true;
			this.showOnlineLowTouch 	= true;
			this.showOnlineMiddleTouch	= true;
			this.showOnlineHighTouch 	= true;
			this.showOnlineNoneTouch 	= true;

			let result = this.merchant_online;

			if (!this.search_merchant){
				return result;
			}

			const filterValue = this.search_merchant.toLowerCase();

			const filter = event =>
				event.name.toLowerCase().includes(filterValue) ||
				event.number.toLowerCase().includes(filterValue) ||
				this.type_translate(event.type).toLowerCase().includes(filterValue);

			return result.filter(filter);
		},

		merchant_online_pb_eleva_search() {
			this.showOnline = true;
			this.showOnlinePBEleva = true;

			let result = this.merchant_online_pb_eleva;

			if (!this.search_merchant){
				return result;
			}

			const filterValue = this.search_merchant.toLowerCase();

			const filter = event =>
				event.name.toLowerCase().includes(filterValue) ||
				event.number.toLowerCase().includes(filterValue) ||
				this.type_translate(event.type).toLowerCase().includes(filterValue);

			return result.filter(filter);
		},

		merchant_online_top_tear_search() {
			this.showOnline = true;
			this.showOnlineTopTier = true;

			let result = this.merchant_online_top_tear;

			if (!this.search_merchant){
				return result;
			}

			const filterValue = this.search_merchant.toLowerCase();

			const filter = event =>
				event.name.toLowerCase().includes(filterValue) ||
				event.number.toLowerCase().includes(filterValue) ||
				this.type_translate(event.type).toLowerCase().includes(filterValue);

			let ret = result.filter(filter);
			this.top_tier_length = ret.length;

			return result.filter(filter);
		},

		merchant_online_high_touch_search() {
			this.showOnline = true;
			this.showOnlineHighTouch = true;

			let result = this.merchant_online_high_touch;

			if (!this.search_merchant){
				return result;
			}

			const filterValue = this.search_merchant.toLowerCase();

			const filter = event =>
				event.name.toLowerCase().includes(filterValue) ||
				event.number.toLowerCase().includes(filterValue) ||
				this.type_translate(event.type).toLowerCase().includes(filterValue);

			return result.filter(filter);
		},

		merchant_online_middle_touch_search() {
			this.showOnline = true;
			this.showOnlineMiddleTouch = true;

			let result = this.merchant_online_middle_touch;

			if (!this.search_merchant){
				return result;
			}

			const filterValue = this.search_merchant.toLowerCase();

			const filter = event =>
				event.name.toLowerCase().includes(filterValue) ||
				event.number.toLowerCase().includes(filterValue) ||
				this.type_translate(event.type).toLowerCase().includes(filterValue);

			return result.filter(filter);
		},

		merchant_online_low_touch_search() {
			this.showOnline = true;
			this.showOnlineLowTouch = true;

			let result = this.merchant_online_low_touch;

			if (!this.search_merchant){
				return result;
			}

			const filterValue = this.search_merchant.toLowerCase();

			const filter = event =>
				event.name.toLowerCase().includes(filterValue) ||
				event.number.toLowerCase().includes(filterValue) ||
				this.type_translate(event.type).toLowerCase().includes(filterValue);

			return result.filter(filter);
		},

		merchant_online_none_touch_search() {
			this.showOnline = true;
			this.showOnlineNoneTouch = true;

			let result = this.merchant_online_none_touch;

			if (!this.search_merchant){
				return result;
			}

			const filterValue = this.search_merchant.toLowerCase();

			const filter = event =>
				event.name.toLowerCase().includes(filterValue) ||
				event.number.toLowerCase().includes(filterValue) ||
				this.type_translate(event.type).toLowerCase().includes(filterValue);

			return result.filter(filter);
		},

		merchant_testing_search() {
			this.showTesting = true;

			let result = this.merchant_testing;

			if (!this.search_merchant){
				return result;
			}

			const filterValue = this.search_merchant.toLowerCase();

			const filter = event =>
				event.name.toLowerCase().includes(filterValue) ||
				event.number.toLowerCase().includes(filterValue) ||
				this.type_translate(event.type).toLowerCase().includes(filterValue);

			return result.filter(filter);
		},

		merchant_closed_search() {
			this.showClosed = true;

			let result = this.merchant_closed;

			if (!this.search_merchant){
				return result;
			}

			const filterValue = this.search_merchant.toLowerCase();

			const filter = event =>
				event.name.toLowerCase().includes(filterValue) ||
				event.number.toLowerCase().includes(filterValue) ||
				this.type_translate(event.type).toLowerCase().includes(filterValue);

			return result.filter(filter);
		},

		merchant_testing_closed_search() {
			this.showTestingClosed = true;

			let result = this.merchant_testing_closed;

			if (!this.search_merchant){
				return result;
			}

			const filterValue = this.search_merchant.toLowerCase();

			const filter = event =>
				event.name.toLowerCase().includes(filterValue) ||
				event.number.toLowerCase().includes(filterValue) ||
				this.type_translate(event.type).toLowerCase().includes(filterValue);

			return result.filter(filter);
		},
	},

	methods: {
		onSubmit(event) {
			event.preventDefault();
			return false;
		},

		openSearchOrder() {
			this.overview_search = !this.overview_search;
			window.setTimeout(
				function(){
					document.querySelector("#search_order").focus();
				},100
			);
		},

		getListMerchant(event) {

			this.$helper.openLoader();

			var data = new FormData();
			data.append("class", 	"Overview");
			data.append("token", 	this.$cookie.get('token'));
			data.append("username", this.$cookie.get('username'));
			data.append("method",	"getListMerchant");

			this.merchant_testing 			= [];
			this.merchant_closed 			= [];
			this.merchant_online 			= [];
			this.merchant_testing_closed	= [];

			this.merchant_online_low_touch 		= [];
			this.merchant_online_middle_touch	= [];
			this.merchant_online_high_touch 	= [];
			this.merchant_online_top_tear 		= [];
			this.merchant_online_pb_eleva 		= [];
			this.merchant_online_none_touch 	= [];

			this.$helper.axios().post('', data)
				.then((response) => {

					response.data.map((value, key) => {
						if (value.status == 'T') {
							this.merchant_testing.push(value);
						} else if (value.status == '-') {
							this.merchant_closed.push(value);
						} else if (value.status == 'I') {
							this.merchant_testing_closed.push(value);
						} else if (value.status == '#') {
							// Não sei o que fazer - Conta em Manutenção
							this.merchant_closed.push(value);
						} else {
							switch (value.touch_rating_code) {
								case "LT": // Low touch
									this.merchant_online_low_touch.push(value);
									break;
								case "MT": // Middle touch
									this.merchant_online_middle_touch.push(value);
									break;
								case "HT": // High touch
									this.merchant_online_high_touch.push(value);
									break;
								case "TT": // Top tier
									this.merchant_online_top_tear.push(value);
									break;
								case "PE": // PB Eleva
									this.merchant_online_pb_eleva.push(value);
									break;

								default:
									this.merchant_online_none_touch.push(value);
									break;
							}

							this.merchant_online.push(value);
						}
					});
					this.$helper.closeLoader();
				})
				.catch((error) => {
					this.$helper.callback_error(error);
				});
		},

		setMerchant(merchant) {
			// Quando o usuário seleciona o elemento do merchant, precisa que o sistema se transforme naquele merchant
			let xpp  = this.$cookie.get('xpp');

			if(xpp != '*' || this.perm.user.tipo != 'S'){
				alert(this.$t('warningmsg_perm'));
				return false;
			}

			let num = merchant.number;
			let account_payment_active = merchant.account_payment_active;

			this.$cookie.set('xpp', num, {"SameSite": "None", "Secure": ""});

			// Se o merchant for somente pagamento, redireciona para a página de pagamentos
			if(account_payment_active == "Y"){
				this.$router.push('/payment');
			} else {
				this.$cookie.set('search', this.search_order, {"SameSite": "None", "Secure": ""});
				this.$cookie.set('search_type', this.search_order_tipo, {"SameSite": "None", "Secure": ""});
				this.$router.push('/searchorder');
			}
		},

		search_order_overview() {
			// Pesquisa uma ordem, e-mail ou boleto, em cada um dos merchants.

			var data = new FormData();
			data.append("class",				"Overview");
			data.append("method",				"getSearchOrderOverview");
			data.append("token",				this.$cookie.get('token'));
			data.append("username",				this.$cookie.get('username'));
			data.append("search_order",			this.search_order);
			data.append("search_order_tipo",	this.search_order_tipo);

			if(this.search_order == ''){
				this.getListMerchant();
				return false;
			}

			this.$helper.openLoader();

			this.$helper.axios().post('', data)
				.then((response) => {
					this.$helper.closeLoader();

					this.merchant_testing 			= [];
					this.merchant_closed 			= [];
					this.merchant_online 			= [];
					this.merchant_testing_closed	= [];

					this.merchant_online_low_touch 		= [];
					this.merchant_online_middle_touch	= [];
					this.merchant_online_high_touch 	= [];
					this.merchant_online_top_tear 		= [];
					this.merchant_online_pb_eleva 		= [];
					this.merchant_online_none_touch 	= [];


					response.data.map((value, key) => {
						if (value.find === '1') {
							if (value.status == 'T') {
								this.merchant_testing.push(value);
							} else if (value.status == '-') {
								this.merchant_closed.push(value);
							} else if (value.status == 'I') {
								this.merchant_testing_closed.push(value);
							} else if (value.status == '#') {
								// Não sei o que fazer - Conta em Manutenção
								this.merchant_closed.push(value);
							} else {
								switch (value.touch_rating_code) {
									case "LT": // Low touch
									this.merchant_online_low_touch.push(value);
										break;
									case "MT": // Middle touch
									this.merchant_online_middle_touch.push(value);
										break;
									case "HT": // High touch
									this.merchant_online_high_touch.push(value);
										break;
									case "TT": // Top tier
									this.merchant_online_top_tear.push(value);
										break;
									case "PE": // PB Eleva
									this.merchant_online_pb_eleva.push(value);
										break;

									default:
									this.merchant_online_none_touch.push(value);
										break;
								}

								this.merchant_online.push(value);
							}
						}
					});
				})
				.catch((error) => {
					this.$helper.callback_error(error);
				});
		},

		type_translate(val) {
			let ret = "";

			switch(val){
				case '2':
					ret = " - Gateway";
					break;
				case '4':
					ret = " - Associated Remittance";
					break;
				case '5':
					ret = " - Payout";
					break;
				case '6':
					ret = " - Hybrid";
					break;
			}

			return ret;
		},

		changeShowOnline() {
			this.showOnline = !this.showOnline;
		},

		changeShowOnlineLowTouch() {
			this.showOnlineLowTouch = !this.showOnlineLowTouch;
		},

		changeShowOnlineMiddleTouch() {
			this.showOnlineMiddleTouch = !this.showOnlineMiddleTouch;
		},

		changeShowOnlineHighTouch() {
			this.showOnlineHighTouch = !this.showOnlineHighTouch;
		},

		changeShowOnlineTopTier() {
			this.showOnlineTopTier = !this.showOnlineTopTier;
		},

		changeShowOnlinePBEleva() {
			this.showOnlinePBEleva = !this.showOnlinePBEleva;
		},

		changeShowOnlineNoneTouch() {
			this.showOnlineNoneTouch = !this.showOnlineNoneTouch;
		},

		changeShowTesting() {
			this.showTesting = !this.showTesting;
		},

		changeShowClosed() {
			this.showClosed = !this.showClosed;
		},

		changeShowTestingClosed() {
			this.showTestingClosed = !this.showTestingClosed;
		},
	},

	filters: {
		limiteName(val) {
			let ret = val;

			if(val.length > 35){
				ret = val.substr(0,35) + "...";
			}

			return ret;
		},

		type_translate(val) {
			let ret = "";

			switch(val){
				case '2':
					ret = "GW"; // Gateway
					break;
				case '4':
					ret = "AR"; // Associated Remittance
					break;
				case '5':
					ret = "PO"; // Payout
					break;
				case '6':
					ret = "HY"; // Hybrid
					break;
			}

			return ret;
		},

		gateway_translate(gateway) {
			var ret = '';

			switch(gateway){
				case "C":
					ret = "-C";
					break;
				case "E":
					ret = "-E";
					break;
				case "R":
					ret = "-R";
					break;
				case "S":
					ret = "-S";
					break;
				case "O":
					ret = "-O";
					break;
				case "G":
					ret = "-G";
					break;
				case "D":
					ret = "-D";
					break;
			}

			return ret;
		}
	}
}
</script>

<style lang="scss" scoped>

	::v-deep .overview_group {
		overflow: hidden;
	}

	::v-deep .overview_group::-webkit-scrollbar {
		width: 12px; // Largura da barra de rolagem (https://developer.mozilla.org/pt-BR/docs/Web/CSS/::-webkit-scrollbar)
	}

	::v-deep .overview_group::-webkit-scrollbar-thumb {
		background-color: transparent; // Cor do polegar da barra de rolagem (https://developer.mozilla.org/pt-BR/docs/Web/CSS/::-webkit-scrollbar)
	}

	::v-deep .overview_group::-webkit-scrollbar-track {
		background-color: transparent; // Cor da trilha da barra de rolagem (https://developer.mozilla.org/pt-BR/docs/Web/CSS/::-webkit-scrollbar)
	}
</style>
